import * as Cookies from 'js-cookie';
import { AccessTokenStorage } from './AccessTokenStorage';

export class CookieAccessTokenStorage implements AccessTokenStorage {
	public constructor(private readonly cookieName: string, private readonly options: { domain?: string }) {}

	public load(): string | null {
		// tslint:disable:no-unsafe-any
		return Cookies.get(this.cookieName) ?? null;
	}

	public remove() {
		// tslint:disable:no-unsafe-any
		Cookies.remove(this.cookieName, this.options);
		if (this.load() !== null) {
			throw new Error(`Failed to remove cookie ${this.cookieName}`);
		}
	}

	public save(token: string, expires: Date) {
		// tslint:disable:no-unsafe-any
		Cookies.set(this.cookieName, token, { ...this.options, expires });
		if (this.load() !== token) {
			throw new Error(`Failed to set cookie ${this.cookieName}`);
		}
	}
}
